// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__13xUy","topBottomGutter":"Layout_topBottomGutter__3MWfX"};